import { UserMenu as AntdUserMenu } from "@empglabs/backoffice-ui-kit"

const UserMenu = props => {
  return <AntdUserMenu {...props} />
}

export default UserMenu
